//const { forEach } = require("lodash");

angular.module('sensores', [])
    .controller('sensoresController', ['$scope', '$rootScope', '$routeParams', '$location', 'sensoresService', 'authenticationInfo', 'authenticationService',
        function ($scope, $rootScope, $routeParams, $location, sensoresService, authenticationInfo, authenticationService) {


        $scope.authentication = authenticationInfo;
        $scope.InfraestructuraId = $routeParams.id;
        $scope.TunelId = $routeParams.TunelId;
        $rootScope.TunelId = $routeParams.TunelId;




        sensoresService.getSensores($scope.InfraestructuraId)
            .then(function (response) {
                var data = response.data;
                $scope.sensores = data;
            });

        $scope.verSensor = function (idSensor) {
            $location.url('/sensores/' + idSensor);
        }

        $scope.volver = function () {
            $rootScope.inspeccionUrl == false;
            $rootScope.parteUrl == false;
            $location.path('/categorias');
        };

    }]);

